import * as React from 'react';
import { connect } from "react-redux";
import { resolve } from 'inversify-react';
import IdentityService from '../../services/identity.service';
import { RouteComponentProps } from 'react-router-dom';
import { actions as nameActions } from '../../actions/name.actions';
import { actions } from '../../actions/main.actions';
import { actions as homeActions } from '../../actions/home.actions';
import { IApplicationState } from "../../typings";

interface IProps {
    redirectTo: string;
    saveWallet: string;
    isVerified: boolean;
}

interface IState{
    showWarning: boolean;
    second: number;
}

type Props = IProps & RouteComponentProps<any> & typeof actions & typeof homeActions;

class WatchIntegrityWrapper extends React.Component<Props, IState> {

    @resolve
    identity: IdentityService;

    constructor(props: Props){
        super(props);

        this.state = {
            showWarning: false,
            second: 0
        }
    }

    componentDidMount(){
        /*if(!this.state.showWarning && !this.props.saveWallet && this.identity.isAuthenticated() && this.identity.userInfo){
            this.setState({showWarning: true, second: 6});
            this.startCountDown();
        }*/
    }

    componentWillUnmount(){
        this.setState({showWarning: false, second: 6});
        clearInterval(this.interval);
    }

    interval;

    startCountDown(){
        this.interval = setInterval(() => {
            if(this.state.second <= 0){
                this.props.history.push(this.props.redirectTo);
                console.log("Redirecting to account settings");
                clearInterval(this.interval);
                return
            }

            this.setState({second: this.state.second - 1})
            

        }, 1000)
    }

  render() {

    if(this.state.showWarning)
    {
        return (
            <div className="redirection-warning">
                <h2>There is no valid wallet address</h2>
                <p>You must save a valid wallet address in yout profile information to receive and send art tokens with our platform.<br/> You will be redirected in {this.state.second} seconds</p>
            
            </div>
        )
    }
    return this.props.children
  }
}


function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        ...ownProps,
        ...state.routing,

        saveWallet: state.identity.userInfo? state.identity.userInfo.wallet_address: '',
        isVerified: state.identity.userInfo? state.identity.userInfo.is_verified: ''
    }
}

export default  connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(WatchIntegrityWrapper);


// WEBPACK FOOTER //
// ./src/core/ui/watchIntegrityWrapper.tsx